// extracted by mini-css-extract-plugin
export var addButton = "_f5-0";
export var border = "_f5-8";
export var check = "_f5-h";
export var danger = "_f5-6";
export var dropdownContainer = "_f5-1";
export var editModalBody = "_f5-j";
export var footerContainer = "_f5-i";
export var fullWidth = "_f5-a";
export var hide = "_f5-9";
export var icon = "_f5-3";
export var input = "_f5-7";
export var inputFlex = "_f5-b";
export var inputWrapper = "_f5-c";
export var manualFocus = "_f5-5";
export var optionButton = "_f5-4";
export var pillWrapper = "_f5-e";
export var pointer = "_f5-2";
export var showOverflow = "_f5-f";
export var tagsFlex = "_f5-d";
export var xButton = "_f5-g";